import React, { useState, useEffect, useContext } from 'react';

import * as net from "../../lib/net";
import * as utils from "../../assets/utils";

import Lid_add from "./fkn/lid_add";
import Lid_open from "./fkn/lid_open";
import Td_Sel from "../../lib/ui/td_sel";

function web01() {

    var html =
        <h4>Huvud</h4>
    ;
    return html;
}

class Wrk_Lreg extends React.Component {
  constructor(props, context) {
    super(props);

    this.store = props.store;
    this.state = {};
    this.state.seldate = new Date();
    this.state.avd = "01";

      this.state.loa = [];
      this.state.lka = [];

    this.state.tro = {};
    this.state.wnds = {};
    this.state.typ = "";
    this.state.sz_val = "";
    this.state.sortid = "";
    this.state.sortdir = 1;

    this.selitems = [
        {fkn: 'open', text: 'ÖPPNA'},
        {fkn: 'status', text: 'STATUS'},
        {fkn: 'remove', text: 'TA BORT'}
    ];
  }
  componentDidUpdate() {
  }
  componentWillUnmount() {
  }
  componentDidMount() {
    this.lreg();
  }

  body_style() {
      var css = {};
      css.height = window.innerHeight - 280;
      return css;
  }
  tb_style() {
      var css = {};
      css.height = window.innerHeight - 225;
      css.overflow = "auto";
      return css;
  }
    th_style(id) {
        var css = {};
        css.cursor = "pointer";
        if(id == this.state.sortid) css.color = "#080";
        return css;
    }
  tab_style(typ) {
      var css = {};
      if(this.state.typ == typ) { css.background = "#009900"; css.color = "#fff"; }
      return css;
  }
  onUnitChange(e) {
        this.setState({unit: e.value});
  }

  lid_add() {
    var self = this;
    var wnds = {};
    wnds.lidadd = true;
    wnds.cb = self.cb_lid;
    this.setState({ wnds: wnds });
  }
  lid_edit(row) {
    var self = this;
    var wnds = {};
    wnds.lidedit = true;
    wnds.lko = row;
    wnds.cb = self.cb_lid;
    this.setState({ wnds: wnds });
  }
  cb_lid(ctx) {
    ctx.setState({ wnds: {} });
    ctx.lreg();
  }

  lreg() {
    var self = this;
    self.setState({typ: "trs", tsa: [] });

    var prm = {};
    prm.req = "bcs.lreg.levs";
    prm.typ = "L";

    net.sio_req(prm)
    .then(function(ret){
        //alert(JSON.stringify(ret.rca));

        self.setState({loa: ret.rca, lka: ret.rca }, function () {
            self.syncTb("lkTable");
        });
    })
    .catch(function(e) {
        var txt = JSON.stringify(e);
        //gda.wndError(txt);
    });
  }
    syncTb(tb) {
        if (!document.getElementById(tb)) {
            //alert("No tb");
            return;
        }
        var tbel = document.getElementById(tb);
        const thElements = tbel.getElementsByTagName('th'),
        tdElements = tbel.getElementsByTagName('td');
        if(tdElements.length < 1 ) return;

        for (let i = 0; i < thElements.length; i++) {
            const widerElement =
                    thElements[i].offsetWidth > tdElements[i].offsetWidth ? thElements[i] : tdElements[i],
            width = window.getComputedStyle(widerElement).width;
            thElements[i].style.width = tdElements[i].style.width = width;
        }
    }
   tb_sort(typ) {
      var self = this;
      //var rvs = self.state.rvs;
      var lka = self.state.lka;
      var sz = this.state.sz_val;
       var sortid = this.state.sortid;
       var sortdir = this.state.sortdir;

       if(sortid != typ) sortdir = 0;
       else {
           if(sortdir) sortdir = 0;
           else sortdir = 1;
       }

       if(sortdir) lka.sort((a,b) => (a.lk00[typ] > b.lk00[typ]) ? 1 : ((b.lk00[typ] > a.lk00[typ]) ? -1 : 0));
       else lka.sort((a,b) => (a.lk00[typ] < b.lk00[typ]) ? 1 : ((b.lk00[typ] < a.lk00[typ]) ? -1 : 0));
      self.setState({ lka: lka, sortid: typ, sortdir: sortdir });
   }
  sel_row_fkn(row, sel) {
      //alert(JSON.stringify(fkn));
    if(sel.fkn == "open") {
        //this.sel_gst(row);
    }
    if(sel.fkn == "br") {
    }
  }
   refresh() {
      var self = this;
      self.lreg();
    }
    sz_keydown (e) {
        //e.preventDefault();
        const key = e.key;
        const keyCode = e.keyCode;

        if(keyCode == 13) {
            this.lreg_sz();
        };
        if(keyCode == 27) {
            this.setState({sz_val: ""});
        };
    }
    sz_change (e) {
        const name = e.target.name;
        const value = e.target.value;
        this.setState({sz_val: value});
        //setState({[name]: value});
    }
    lreg_sz() {
        var self = this;
        var loa = self.state.loa;
        var sz = this.state.sz_val;

        //var kka = koa.filter(row => row.kk00.ftg.toUpperCase().includes(sz.toUpperCase()));
        var lka = loa.filter(row => row.lk00.ftg.toUpperCase().includes(sz.toUpperCase()));
        self.setState({lka: lka });
    }

  render() {
    return (
    <div className="web-app">
    <div className="flex-row flex-space-between">
        <div className="flex-row">
            <input className="txt sztxt" value={this.state.sz_val} onChange={(e) => this.sz_change(e)} onKeyDown={(e) => this.sz_keydown(e)} />
        </div>

        <div className="flex"></div>

        <div className="flex-row">
        <button className="btn btn-hw-orange w150" onClick={() => this.lid_add() } aria-label="System" >
            LÄGG TILL
        </button>
        <button className="btn btn-hw-blue w150" onClick={() => this.refresh() } aria-label="System" >
            UPPDATERA
        </button>
        </div>
    </div>
    <div className="divider_orange"></div>

        <div id="lkTable" className="flex">
          <table className="table table-bordered table-hover tb" style={{marginBottom: "0px"}}>
            <thead>
            <tr>
                <th style={ this.th_style("lid") } onClick={() => this.tb_sort("lid") }>LID</th>
                <th style={ this.th_style("text") } onClick={() => this.tb_sort("text") }>Text</th>
                <th style={ this.th_style("ftg") } onClick={() => this.tb_sort("ftg") }>Företag</th>
                <th style={ this.th_style("ref") } onClick={() => this.tb_sort("ref") }>Referens</th>
                <th style={ this.th_style("orgnr") } onClick={() => this.tb_sort("orgnr") }>Orgnr</th>
                <th style={ this.th_style("tele") } onClick={() => this.tb_sort("tele") }>Tele</th>
                <th style={ this.th_style("reg") } onClick={() => this.tb_sort("reg") }>Start</th>
                <th></th>
            </tr>
            </thead>
        </table>
        <div style={ this.tb_style() }>
          <table className="table table-bordered table-hover tb">
            <tbody>
            { this.state.lka.map((row, key) =>
            <tr key={key} onDoubleClick={() => this.lid_edit(row) }>
                <td>{ utils.toNum( row.lk00.lid ) }</td>
                <td>{ utils.toLang( row.lk00.text ) }</td>
                <td>{ utils.toLang( row.lk00.ftg ) }</td>
                <td>{ row.lk00.ref }</td>
                <td>{ row.lk00.orgnr }</td>
                <td>{ row.lk02.tele }</td>
                <td>{ utils.toDate( row.lk00.reg ) }</td>
                <td>
                    <Td_Sel items={ this.selitems } getValue={(e)=> this.sel_row_fkn(row, e)} />
                </td>
            </tr>
            )}
            </tbody>
        </table>
        </div>
    </div>
        { this.state.wnds.lidadd ? <Lid_add wnds={this.state.wnds} ctx={this} store={this.props.store} backdrop={true}/> : null }
        { this.state.wnds.lidedit ? <Lid_open wnds={this.state.wnds} ctx={this} store={this.props.store} backdrop={true}/> : null }

   </div>
  );
  }
}
export default Wrk_Lreg;
/*

*/